$(document).ready(function () {
    $('.process-expand').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).parent().parent().next('.process-list-item-content').toggleClass('open');
    })

    var processListItems = $('.process-list-item');
    processListItems.each(function (i) {
        var processListItem = processListItems[i];
        var waypoint = new Waypoint({
            element: processListItem,
            handler: function (direction) {
                $(processListItem).addClass('in-view');
                this.destroy();
            },
            offset: '95%'
        });
    })

});

